<template>
  <div>
    <div class="box" v-if="value">
      <div class="h5 main" style="padding:20px 0 48px 0">주문제작 상담 상세</div>
      <div class="columns">
        <div class="column is-5" style="padding-right: 30px">
          <div class="detail-title">서비스 정보</div>
          <div style="margin-bottom:80px">
            <div class="flex">
              <div class="col-4">
                <div class="subtitle7 sub3">작성일자</div>
                <div class="body2 sub2">{{ datesFormat(value.created_time, 'date_time_2') }}</div>
              </div>
              <div class="col-4">
                <div class="subtitle7 sub3">진행 상태</div>
                <div class="flex">
                  <div :class="`status status-${value.status}`">{{ contentStatus(value) }}</div>
                </div>
              </div>
              <div class="col-4">
                <div class="subtitle7 sub3">문의 유형</div>
                <div class="body2 sub3">{{ value.channel }}</div>
              </div>
            </div>

            <template v-if="value.api_request && value.api_request.name">
              <div class="subtitle7 sub3">주문전환 방식</div>
              <div class="body2 sub2 word-wrap">{{ value.api_request.packages.toString() }}</div>
              <div class="subtitle7 sub3">제공 범위</div>
              <div class="body2 sub2 word-wrap">{{ value.api_request.support }}</div>
              <div class="subtitle7 sub3">요청사항</div>
              <div class="body2 sub2 word-wrap">{{ value.api_request.content }}</div>
            </template>
            <template v-else>
              <div class="subtitle7 sub3 word-wrap">서비스 이름</div>
              <div class="body2 sub2">{{ value.service_name }}</div>
              <div class="subtitle7 sub3">서비스 소개</div>
              <div class="body2 sub2 word-wrap">{{ value.content }}</div>
              <div class="subtitle7 sub3">제작예산</div>
              <div class="body2 sub2">{{ value.account|currencyNum }}만원</div>
              <div class="subtitle7 sub3">희망 소요기간</div>
              <div class="body2 sub2">{{ value.hope_date }}개월</div>
              <div class="subtitle7 sub3">참고자료</div>
              <template v-if="value.files" v-for="(file, file_idx) in value.files">
                <div class="body2 sub2 flex-align" :key="`file-${file_idx}`">
                  <img :src="svgSrc('u_paperclip')"
                       class="svg-sub3 margin-right-8"
                       style="width:18px;height:18px"/>
                  <a :href="file" target="_blank">{{ file.split('/').pop() }}</a></div>
              </template>
              <div class="subtitle7 sub3">서비스 지원환경</div>
              <div class="body2 sub2">{{ value.support }}</div>
            </template>
          </div>

          <div class="detail-title">신청자 정보</div>
          <div>
            <div class="subtitle7 sub3">성함(혹은 회사명)</div>
            <div class="body2 sub2">{{ value.name }}</div>
            <div class="subtitle7 sub3">연락처</div>
            <div class="body2 sub2">{{ value.phone }}</div>
            <div class="subtitle7 sub3">이메일</div>
            <div class="body2 sub2">{{ value.email }}</div>
          </div>
        </div>
        <div v-if="value.talk && value.talk > 0" class="column is-7" style="padding-left:30px">
          <launch-talk :isMemo="!value.user || value.user.guest" :talkId="value.talk" :talks.sync="talks"></launch-talk>
        </div>
      </div>
    </div>
    <div class="flex-center" style="margin-top:80px">
      <button class="button is-gray" style="width:242px;height:52px !important;font-size:15px !important;" @click="$router.back()">목록으로</button>
    </div>
  </div>
</template>

<script>
  import LaunchTalk from "../../../module/common/LaunchTalk";

  export default {
    layout: 'Main',
    name: 'ServiceInquiryDetail',
    components: {LaunchTalk},
    data() {
      return {
        value: {},
        talks: [],
      }
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        this.$axios.get(this.getUrl(`launchpack/service/inquiry/${this.$route.query.id}`))
          .then(res => {
            if (res.status === 200) {
              this.value = res.data;
            }
          })
      },
      contentStatus(menu) {
        let status = {
          0: '신청 미확인',
          1: '신청 확인',
          2: '상담완료'
        };
        let result = status[menu.status];
        if(menu.status === 2 && menu.service_status > 0) {
          result = menu.service_status === 1 ? '서비스 미등록' : '서비스 등록';
        }
        return result;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .detail-title
    color $main
    font-size 24px
    line-height 34px
    font-weight 500
    padding-bottom 16px
    border-bottom 1px solid $sub5
    margin-bottom 32px

  .grid
    grid-template-columns 0.3fr 1fr
    grid-row-gap 16px

  .clip
    transform rotate(45deg)
    color $sub3
    font-size 18px
    vertical-align sub
    margin-right 8px

  .subtitle7
    margin 24px 0 4px 0
  .subtitle7:first-child
    margin-top 0

  a
    text-decoration underline

  .word-wrap
    white-space pre-line
    word-break break-word

  .status
    padding 4px 8px
    border-radius 4px
    font-size 13px
    font-weight 500
  .status-0
    background-color $gray3
    color $sub2
  .status-1
    background-color $gray3
    color $primary
  .status-2
    background-color $primary-light2
    color $primary
</style>
